import React from "react";
import { useTranslation } from "react-i18next";
import useRevealSection from "../hooks/useRevealSection";

const Skill: React.FC = () => {
  const { t } = useTranslation();
  const sectionRef = useRevealSection<HTMLElement>();

  return (
    <section className="skills" id="skills" ref={sectionRef}>
      <h2 className="heading reveal">
        {t("skills.headingPre")} <span>{t("skills.headingSpan")}</span>
      </h2>

      <div className="skills-row">
        <div className="skills-column reveal reveal-left">
          <h3 className="title">{t("skills.technicalTitle")}</h3>
          <div className="skills-box">
            <div className="skills-content">
              <h3>{t("skills.labels.languages")}</h3>
              <p> PHP, JavaScript, TypeScript, Swift, Python, C#, Objective-C</p>
              <h3>{t("skills.labels.frameworks")}</h3>
              <p> Symfony, Laravel, React</p>
              <h3>{t("skills.labels.platforms")}</h3>
              <p> Web, iOS, Android</p>
              <h3>{t("skills.labels.ai")}</h3>
              <p> {t("skills.aiDesc")}</p>
              <h3>{t("skills.labels.databases")}</h3>
              <p> MySQL, NoSQL</p>
              <h3>{t("skills.labels.formats")}</h3>
              <p> XML, JSON</p>
            </div>
          </div>
        </div>

        <div className="skills-column reveal reveal-right">
          <h3 className="title">{t("skills.entrepreneurTitle")}</h3>
          <div className="skills-box">
            <div className="skills-content">
              <h3>{t("skills.ownership.label")}</h3>
              <p>{t("skills.ownership.desc")}</p>
              <h3>{t("skills.productThinking.label")}</h3>
              <p>{t("skills.productThinking.desc")}</p>
              <h3>{t("skills.selfOrg.label")}</h3>
              <p>{t("skills.selfOrg.desc")}</p>
              <h3>{t("skills.learning.label")}</h3>
              <p>{t("skills.learning.desc")}</p>
              <h3>{t("skills.communication.label")}</h3>
              <p>{t("skills.communication.desc")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skill;
